const relatives = ['오늘', '어제', '이번 주', '이번 달', '월'];

const setToMidnight = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};

export default function getRelativeDateFromToday(inputDate) {
    const today = setToMidnight(new Date());

    // 입력된 날짜와 오늘의 차이(밀리초)
    const diffTime = today - setToMidnight(new Date(inputDate));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // 밀리초 -> 일(day)로 변환
    
    // 오늘 날짜 비교
    if (diffDays === 0) {
        return relatives[0]; // '오늘'
    }

    // 어제 날짜 비교
    if (diffDays === 1) {
        return relatives[1]; // '어제'
    }

    // 7일 이내의 날짜면 '이번 주'
    if (diffDays <= 7) {
        return relatives[2]; // '이번 주'
    }

    // 8일 ~ 30일 이내의 날짜면 '이번 달'
    if (diffDays <= 30) {
        return relatives[3]; // '이번 달'
    }

    // 31일 이상이라면 해당 월(month)을 반환
    const inputMonth = new Date(inputDate).getMonth() + 1; // month는 0부터 시작하므로 +1 필요
    return `${inputMonth}${relatives[4]}`; // e.g. '8월'
};